/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Map_UrlInputs */



/**
* | output |
* | --- |
* | "Map URL" |
*
* @param {Tfield_Map_UrlInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_map_url = /** @type {((inputs?: Tfield_Map_UrlInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Map_UrlInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL de la carte")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL del mapa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("URL do Mapa")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL Mappa")
	return /** @type {LocalizedString} */ ("Map URL")
});